export default {
  devices: [],
  roamingDevices: [],
  networkTypes: [],
  deviceTypes: [],
  manufacturers: [],
  deviceTopics: [],
  deviceEndpoints: []
};